import * as PIXI from 'pixi.js';
import FlashLib from 'flashlib';
import { requestConfig } from '../api/rest';
import ControllerButtonPlay from './buttonPlay';
import WebFont from 'webfontloader';
import ControllerBalanceView from './controllerBalanceView';
import ControllerBetSelector from './controllerBetSelector';
import ControllerSounds from './controllerSounds';
import AnimationsLoader from './animations/animationsLoader';
import ControllerButtonSound from './buttonSoundMute';
import ControllerStartScreen from './controllerStartScreen';
import ControllerTextField from './textField/ControllerTextField';
import EMAdapter from '../platforms/everyMatrix/adapter';
import Config from './Config';
import en from '../../assets/i18n/en.json';
import enSocial from '../../assets/i18n/en-social.json';
import OPWrapperService from '../libs/op-wrapper-service';
import FlashLibJson from '../../assets/exported/game/FlashLib.json';

export default class Game {
  constructor() {
    this.app = null;
    this.compiled = false;

    this.fontsLoaded = false;
    this.assetsLoaded = false;
    this.configReceived = false;
    this.soundsLoaded = false;
    this.animationsLoaded = false;

    PIXI.settings.FAIL_IF_MAJOR_PERFORMANCE_CAVEAT = false;

    FlashLib.TextField = ControllerTextField;

    this.start();
    EMAdapter.init();
  }

  start() {
    this.container = document.getElementById('container');
    this.applicationOptions = {
      // antialias: true,
      // backgroundColor: 0x6fc1f6,
      // legacy: true,
      resolution: window.devicePixelRatio < 2 ? window.devicePixelRatio : 2,
    };

    this.app = new PIXI.Application(this.applicationOptions);

    this.app.view.id = 'gameCanvas';
    this.container.appendChild(this.app.view);

    this.initWrapperService()

    this.loadAssets();
    this.loadFonts();

    ControllerSounds.startLoading(() => {
      console.log('Sounds loaded');
      this.soundsLoaded = true;
      this.tryInitGame();
    });

    AnimationsLoader.startLoading(this.app, () => {
      console.log('Animations loaded');
      this.animationsLoaded = true;
      this.tryInitGame();
    });

    requestConfig()
      .then(() => {
        console.log('Config received');
        this.configReceived = true;
        this.tryInitGame();
      });
  }

  initWrapperService() {
    this.gameSize = {
      mobileLandscape: {
        width: 2340,
        height: 1080
      },
      mobilePortrait: {
        width: 1080,
        height: 2340
      },
      desktop: {
        width: 2340,
        height: 1080
      },
    };
    this.scaleData = {
      app: this.app,
      gameSize: this.gameSize
    };
    new OPWrapperService({
      bundle: 'goldenclover',
      localizations: { en, 'en-social': enSocial },
      localizationBundle: 'goldenclover',
      lang: 'en',
      fallbackLang: 'en',
      scaleData: { data: this.scaleData, config: Config },
    });
  }

  loadAssets() {
    const assets = `assets/flashlib/game/AssetsCombined@1.0x.json`;

    PIXI.Loader.shared.baseUrl = './';
    PIXI.Loader.shared.add('FlashLib', FlashLibJson, 'json');
    PIXI.Loader.shared.add('GameAssets', assets, 'json');
    PIXI.Loader.shared.add('BmFontPhosphate', 'assets/fonts/bmFonts/BmFontPhosphate/BmFontPhosphate.fnt');
    PIXI.Loader.shared.add('BmFontPhosphate_white', 'assets/fonts/bmFonts/BmFontPhosphate_white/BmFontPhosphate_white.fnt');

    PIXI.Loader.shared.once('complete', () => {
      console.log('Assets loaded');
      this.assetsLoaded = true;
      this.tryInitGame();
    }, this);
    PIXI.Loader.shared.on('progress', (data) => {
      OPPreloader.setProgress(data.progress);
      EMAdapter.loadProgress(data.progress);
    });
    PIXI.Loader.shared.on('error', this.onLoadingError.bind(this));
    PIXI.Loader.shared.load();
  }

  loadFonts() {
    WebFont.load({
      custom: {
        families: ['Phosphate Pro solid', 'Ubuntu bold', 'Ubuntu', 'Inter Extra Bold'],
      },
      fontinactive: console.error,
      fontloading: console.log,
      active: () => {
        console.log('Fonts loaded');
        this.fontsLoaded = true;
        this.tryInitGame();
      },
      inactive: this.onLoadingError.bind(this),
      timeout: 60000
    });
  }

  onLoadingError(err) {
    console.error(err);
    window.OPWrapperService.showError(window.OPWrapperService.errors.ASSETS_ERROR.CODE);
    PIXI.Loader.shared.reset();
  }

  tryInitGame() {
    if (this.fontsLoaded &&
      this.assetsLoaded &&
      this.configReceived &&
      this.soundsLoaded &&
      this.animationsLoaded) {
      window.OPPreloader.hide();
      this.initGame();
    }
  }

  initGame() {
    EMAdapter.loadCompleted();
    let main = FlashLib.createItemFromLibrary('main', 'FlashLib');
    let field = main.getChildByName('field');
    this.app.stage.addChild(main);

    new ControllerStartScreen(main.getChildByName('startScreen'));
    new ControllerButtonPlay(main);
    new ControllerBalanceView(main);
    new ControllerBetSelector(main);
    new ControllerButtonSound(field);
    field.getChildByName('buttonMenu').addListener('pointertap', () => {
      OPWrapperService.toggleSidebar();
    });
    window.OPWrapperService.ScaleManager.init(this.scaleData, Config);
  }
}
